import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { toastr } from "react-redux-toastr";
import {
  getDataFromAPI,
  getseedDataFromAPI,
  CreatevmAPI,
  UploadImgAPI,
  getCityDataFromAPI,
} from "../HandleAPICalls/actions";
import parseResponseToOptions, {
  parseVMTypeOptions,
  parseStateAndCityOptions,
  parseCohortOptions,
  parsePaymentsOptions,
  parseWarehouseOptions,
  parseVmHdTypeOptions,
  parseVmLoctonTypeOptions
} from "../../utils/parseResponseToOptions";
import CreateVM from "./component";
import { set } from "lodash";
import { setLoading } from "../Login/actions";
function parseCartLimitOptions(options) {
  if (!options && options.length) {
    return { key: 0, text: 'None', value: 0 };
  }
  const parsed = options.map(el => ({
    key: el,
    text: el,
    value: el
  }));
  return [...parsed];
}

class CreateVendingMachineContainer extends Component {
  constructor() {
    super();
    this.state = {
      vmName: null,
      vmName_capacity:null,
      vmSerialNo: null,
      vmName_mv: null,
      vmName_sv: null,
      warehouseId:null,
      corporateId:null,
      vmName_capacity:null,
      vmStreet: null,
      vmCity: null,
      cityList: [],
      cityLoading: true,
      vmState: null,
      stateList: [],
      stateLoading: true,
      lat: null,
      lng: null,
      imageId: null,
      vmTypeId: null,
      hardware_type_id:null,
      location_type_id:null,
      sharePercentage: 0,
      isConsumerAppEnabled: 0,
      remoteBoardId: null,
      remoteBluetoothId: null,
      remoteComId: null,
      remoteDeviceId: null,
      vmTypeOptions: [],
      vmTypeLoading: true,
      loading: true,
      fetchSeeddata: [],
      cohorts: [],
      payments: [],
      hardware_types: [],
      location_types:[],
      warehouses: [],
      corporates:[],
      machine_types: [],
      searchQuery: [],
      cohortvalue: [],
      searchCohortQuery: [],
      paymentsvalues: [],
      searchPaymentsQuery: [],
      paymentsId: [],
      vmSerialno:null,
     // warehouseId:null,
      isHealthAppEnabled:null,
      image:null,
      allPermission:null,
      cartLimit:null,
      cart_Limt:[],
      loader:false
    };
  }
 

  componentDidMount() {
    this.setState({
      allPermission: JSON.parse(localStorage.getItem('allPermissions'))
   
    });
    

    this.props.getDataFromAPI(
      "/vendingmachines/vmtypes",
      "GET",
      undefined,
      (response) => {
        console.log("user role response", response);
        this.setState({
          vmTypeOptions: parseVMTypeOptions(response.list),
          vmTypeLoading: false,
          loading: false,
        });
      },
      (err) => {
        console.log(err);
        toastr.error("Failed", "Unable to fetch vending machine type list");
        this.setState({ loading: false, vmTypeLoading: false });
      }
    );

    this.props.getDataFromAPI(
      "/vendingmachines/location/states",
      "GET",
      undefined,
      (response) => {
        console.log(
          "user role response list",
          parseStateAndCityOptions(response.list)
        );
        this.setState({
          stateList: parseStateAndCityOptions(response.list),
          stateLoading: false,
          loading: false,
        });
      },
      (err) => {
        console.log(err);
        toastr.error("Failed", "Unable to fetch vending machine type list");
        this.setState({ loading: false, stateLoading: false });
      }
    );

    this.props.getseedDataFromAPI(
      "/partner/api/v2/machine/seed",
      "GET",
      undefined,
      (response) => {
        console.log("SeedData response.location_types", response.location_types);
        this.setState({
          cohorts: parseCohortOptions(response.cohorts),
          payments: parsePaymentsOptions(response.payment_configs),
          hardware_types: parseVmHdTypeOptions(response.hardware_types),
          location_types: parseVmLoctonTypeOptions(response.location_types),
          machine_types: parseVmHdTypeOptions(response.machine_types),
          warehouses: parseWarehouseOptions(response.warehouses),
          corporates: parseWarehouseOptions(response.corporates),
          cart_Limt:parseCartLimitOptions([1,2,3,4,5,6,7,8,9,10])
          //vmTypeLoading: false,
          //loading: false
        });
        console.log(
          "parsePaymentsOptions(response.payment_configs)",
          parsePaymentsOptions(response.payment_configs)
        );
        console.log("Cohortid",this.state.cohorts);
      },

      (err) => {
        console.log(err);
        toastr.error("Failed", "Unable to fetch vending machine type list");
        this.setState({ loading: false, vmTypeLoading: false });
      }
    );
  }

  onChangeOfName = (event) => {
   
    this.setState({ vmName: event.target.value });
    console.log("vmName", this.state.vmName);
    
  };

  onChangeOfName_mv = (event) => {
   
    this.setState({ vmName_mv: event.target.value });
    console.log("MV_ID--", this.state.vmName_mv);
    
  };

  onChangeOfName_sv = (event) => {
   
    this.setState({ vmName_sv: event.target.value });
    console.log("MV_ID--", this.state.vmName_sv);
    
  };
  
  onChangeOWarehouse = (event,data) => {
    console.log("MV_ID--", event);
    this.setState({ warehouseId: data.value });
    console.log("MV_ID--", data.value);
    
  };
  onChangeCorporates = (event,data) => {
    console.log("MV_ID--", event);
    this.setState({ corporateId: data.value });
    console.log("MV_ID--", data.value);
    
  };
  onChange_Capacity=()=>{
    this.setState({ vmName_capacity: event.target.value });
    console.log("vmName_capacity--", this.state.vmName_capacity);
  }


  onChangeOfVMStreet = (event) => {
    this.setState({ vmStreet: event.target.value });
    console.log('vmStreet------------>',this.state.vmStreet);
  };

  onChangeOfLng = (event) => {
    this.setState({ lng: event.target.value });
    console.log("lng------------->",this.state.lng)
  };

  onChangeOfSerialNo = (event) => {
   
    this.setState({ vmSerialNo: event.target.value });
    console.log("vmName", this.state.vmSerialNo);
    
  };
  onChangeOfLat = (event) => {
    this.setState({ lat: event.target.value });
    console.log("lat-------->",this.state.lat)
  };

  onChangeOfVMCity = (event, data) => {
    const values = String(data.value).split('-');
    const city = values[1];
    this.setState({ vmCity: city });
    console.log("city-----------------",this.state.vmCity)
  };
  onChangeOfVMState = (event, data) => {
    console.log()
    const values = String(data.value).split('-');
    const stateId = values[0];
    const state = values[1];
    console.log("state------------------------------------------------------------------------>",stateId)
    this.props.getCityDataFromAPI(
      `/vendingmachines/location/${stateId}/cities`,
      'GET',
      undefined,
      response => {
        this.setState({
          cityList: parseStateAndCityOptions(response.list),
          cityLoading: false,
          vmState: state,
          loading: false
        });
      },
      err => {
        console.log(err);
        toastr.error('Failed', 'Unable to fetch list of cities');
        this.setState({ loading: false, cityLoading: false });
      }
    );
  };

  /* onChangeOfVMState = (event, data) => {
    console.log("DATA------------------STATE--->", data.value);
    const values = String(data.value).split("-");
    const stateId = values[0];
    console.log("stateID--------->",this.state.vmState);


    const state = values[1];
    this.props.getDataFromAPI(
      `/vendingmachines/location/${stateId}/cities`,
      "GET",
      undefined,
      (response) => {
        this.setState({
          cityList: parseStateAndCityOptions(response.list),
          cityLoading: false,
          vmState: stateId,
          loading: false,
        });
      },
      (err) => {
        console.log(err);
        toastr.error("Failed", "Unable to fetch list of cities");
        this.setState({ loading: false, cityLoading: false });
      }
    );
  };
 */
  handleSearchChange = (e, { searchQuery }) => {
    this.setState({ searchCohortQuery: searchQuery });
    /*  console.log("search", this.searchQuery); */
  };

  onChangeOfVMCohort = (event, { searchQuery, value }, data) => {
    console.log("cohort id--------->", data);
    const values = String(value).split("-");
    const stateId = values[0];
    console.log("cohort id--------->", values);
    console.log("Cohortid----->:", this.state.cohorts);
    const state = values[1];
    this.setState({
      cohortvalue: value,
      searchCohortQuery: searchQuery,
    });
  };

  onChangeOfPayments = (event, { searchQuery, value, id }) => {
    console.log("payments--------->", id);
    const values = String(value).split("-");
    const stateId = values[0];
    const state = values[1];
    this.setState({
      paymentsvalues: value,
      paymentsId: { ...stateId, stateId },
      // searchQuery:searchQuery
    });

    console.log("payments id--------->", this.state.paymentsvalues);
  };


 

  onChangeOfImageId = (event, data) => {
    this.setState({ imageId: event.target.value });
  };

  onChangeOfSharePercentage = (event, data) => {
    this.setState({ sharePercentage: event.target.value });
    console.log("sharePercentage:------>",this.state.sharePercentage)
  };

  onChangeOfRemoteBoardId = (event, data) => {
    this.setState({ remoteBoardId: event.target.value });
  };

  onChangeOfRemoteBluetoothId = (event, data) => {
    this.setState({ remoteBluetoothId: event.target.value });
  };

  onChangeOfRemoteComId = (event, data) => {
    this.setState({ remoteComId: event.target.value });
  };

  onChangeRemoteDeviceId = (event, data) => {
    this.setState({ remoteDeviceId: event.target.value });
  };

  onChangeOfVMTypeId = (event, data) => {
    this.setState({ vmTypeId: data.value });
    console.log("vm type id -->",data.value)
  };

  onChangeOfHardWareTypeId=(e,data)=>{
    this.setState({hardware_type_id:data.value});
    console.log("Hard ware type id -->",this.state.hardware_type_id)

  }

  onChangeOfLocationTypeId=(e,data)=>{
    this.setState({location_type_id:data.value});
    console.log("onChangeOfLocationTypeId -->",this.state.location_type_id)

  }
 
  onChangeOfIsConsumerAppEnabled = (event, data) => {
    this.setState({ isConsumerAppEnabled: data.value });
    console.log("isConsumerAppEnabled",this.state.isConsumerAppEnabled)
  };
  
  onChangeOfIsHealthAppEnabled = (event, data) => {
    this.setState({ isHealthAppEnabled: data.value });
    console.log("isHealthAppEnabled",this.state.isHealthAppEnabled)
  };
  handleCreateVM = (inputFields) => {
    // set loading true
    console.log("inputFields------------------",inputFields)
    this.setState({ loading: true });

    const {
      vmName,
      vmName_mv,
      vmSerialNo,
      vmName_capacity,
     

      vmName_sv,
      vmStreet,
      vmCity,
      vmState,
      lat,
      lng,
      imageId,


      vmTypeId,
      hardware_type_id,
      location_type_id,
      cartLimit,
      warehouseId,
      corporateId,
      
      sharePercentage,
      isConsumerAppEnabled,
 
      cohortvalue,
      paymentsvalues,
      vmSerialNumber,
      isHealthAppEnabled,
      imagePath,
    } = this.state;


     const payload = {
      name: vmName,
      hardware_type_id: parseInt(hardware_type_id),
      location_type_id: parseInt(location_type_id),
      machine_type_id: parseInt(vmTypeId),
      health_report_enabled: isHealthAppEnabled,
      consumer_app_enabled:isConsumerAppEnabled,
      share_percentage: sharePercentage,
      warehouse_id: warehouseId,
      corporate_id: corporateId,
      cohort_ids: cohortvalue,
      payment_config_ids:paymentsvalues,
      cart_limit:this.state.cartLimit,
      address: {
        street: vmStreet,
        city: vmCity,
        state: vmState,
        latitude:lat ,
        longitude:lng ,
        image_path:imagePath,
        location_type_id:location_type_id
      },
      serial_number: vmSerialNo,
   
      slots:inputFields,
    };
    {console.log("inputFields[0].slot_id.length",inputFields[0].slot_id&&inputFields[0].slot_id.length>3)}
     if (!vmName || vmName.length < 3) {
      this.setState({ loading: false });
      return toastr.warning('Invalid', 'Vending machine name is too small');
    }
    if (vmName.length > 50) {
      this.setState({ loading: false });
      return toastr.warning('Invalid', 'Vending machine name Max 50 Characters Only');
    }
 
    if (!vmTypeId) {
      this.setState({ loading: false });
      return toastr.warning('Invalid', 'Vending machine type is missing');
    }
    if (!hardware_type_id) {
      this.setState({ loading: false });
      return toastr.warning('Invalid', 'hardware type is missing');
    }
    if (!location_type_id) {
      this.setState({ loading: false });
      return toastr.warning('Invalid', 'loction type is missing');
    }
    if (!warehouseId) {
      this.setState({ loading: false });
      return toastr.warning('Invalid', 'warehouse  location is missing');
    }

    if (!corporateId) {
      this.setState({ loading: false });
      return toastr.warning('Invalid', 'corporate Type is missing');
    }  

 /*    if (!isConsumerAppEnabled) {
      if(!isConsumerAppEnabled==0){
      this.setState({ loading: false });
      return toastr.warning('Invalid', 'ConsumerAppEnabled Not Selected');
    }
  

 
}
  
    
    if (!isHealthAppEnabled) {
      this.setState({ loading: false });
      return toastr.warning('Invalid', 'isHealthAppEnabled Not Selected');
    } 
     */
    
  
  
    if (!vmSerialNo || vmSerialNo.length < 1 ) {
      this.setState({ loading: false });
      return toastr.warning('Invalid', 'Vending machine Serial Number is required, min 3 chars');
    }  
    if (!vmSerialNo || vmSerialNo.length >20 ) {
      this.setState({ loading: false });
      return toastr.warning('Invalid', 'Vending machine Serial Number is required, max 20 chars');
    } 
 
    
    for (let i = 0; i < inputFields.length; i++) {
      if (!inputFields[i].slot_id) {
        this.setState({ loading: false });
        return toastr.warning('Invalid', 'Slot_Id is required');
      }

      if (!inputFields[i].slot_id.length>=3) {

        this.setState({ loading: false });
        return toastr.warning('Invalid', 'Slot_Id required,  3 chars' );
      }
      if (!(inputFields[i].slot_id&&inputFields[i].slot_id.length<5)) {
        this.setState({ loading: false });
        return toastr.warning('Invalid', 'Slot_Id required,  3 min and 4 max chars' );
      }
      if (!inputFields[i].mv_id) {
        this.setState({ loading: false });
        return toastr.warning('Invalid', 'Mv_Id is required');
      }
      if (!inputFields[i].mv_id.length>3) {
        this.setState({ loading: false });
        return toastr.warning('Invalid', 'Mv_id required,  3 chars' );
      }
  
      if (!inputFields[i].capacity) {
        this.setState({ loading: false });
        return toastr.warning('Invalid', 'Capacity is required');
      }
   
    }

    if (!imagePath) {
      this.setState({ loading: false });
      return toastr.warning('Invalid', 'Please Upload Image ');
    }

    
   
   
     if (inputFields.slot_id >3) {
      this.setState({ loading: false });
      return toastr.warning('Invalid', 'Slot_Idrequired,  3 chars' );
    } 
   
     if (!vmStreet || vmStreet.length <3 || vmStreet.length > 100 || vmStreet.length > 100) {
      this.setState({ loading: false });
      return toastr.warning('Invalid', 'Vending machine location is required, min 3 chars & max 100 chars');
    }
    if (!vmCity ) {
      this.setState({ loading: false });
      return toastr.warning('Invalid', 'Vending machine city is required, min 3 chars & min 50 chars');
    }
     
    if (!vmState ) {
      this.setState({ loading: false });
      return toastr.warning('Invalid', 'Vending machine state is required');
    } 
    
    
    if (!lng) {
      this.setState({ loading: false });
      return toastr.warning('Invalid', 'Longitude is  required');
    }
    if (!lng.length>=11 || !lng.length>9) {
      this.setState({ loading: false });
      return toastr.warning('Invalid', 'Longitude  is wrong required');
    }
    if (!lat) {
      this.setState({ loading: false });
      return toastr.warning('Invalid', 'Latitude is  required');
    }
    if (!lat.length>=11 || !lat.length>9) {
      this.setState({ loading: false });
      return toastr.warning('Invalid', 'Latitude is  required');
    }

    console.log("api hiting---------->");

    this.props.CreatevmAPI(
      "/partner/api/v2/machine",
      "POST",
      payload,
      (response) => {
        console.log("api hiting-------responsive--->", response);
        this.props.history.push("/vendingmachines")
      },
      (err) => {
        this.setState({ loading: false });
        console.log("erorrrrrrr",err)
        toastr.error(err.data.status.message);
      }
    );
  };

 UploadImgBtn=(e)=>{
   
  let formData= new FormData()
  formData.append("file",this.state.image)
  this.setState({loader:true})
  console.log("imageform--",formData),
    this.props.UploadImgAPI(
      "/partner/api/v2/s3upload/machine-image",
      "POST",
      formData
      ,
      (response) => {
        console.log("api hiting-------responsive--->", response);
        this.setState({imagePath:response.image_path})
        this.setState({loader:false})
              },
      (err) => {
        this.setState({ loading: false });
        toastr.error(err.message);
        this.setState({loader:false})
      }
    );
  };

  UploadImgFun=(e)=>{
    console.log("eee--->",e.target.files[0])
    this.setState({image:e.target.files[0]})
  
  }
  onChangeCartLimit = (event, data) => {
    this.setState({ cartLimit: data.value });
    console.log("cartLimit -->",data.value)
  };
  
   

  handleBack = () => {
    return this.props.history.push("/vendingmachines");
  };

  render() {
    return (
      <CreateVM
        name={this.state.name}
       
        vmStreet={this.state.vmStreet}
        vmCity={this.state.vmCity}
        vmState={this.state.vmState}
        imageId={this.state.imageId}
        sharePercentage={this.state.sharePercentage}
        remoteBluetoothId={this.state.remoteBluetoothId}
        remoteBoardId={this.state.remoteBoardId}
        remoteComId={this.state.remoteComId}
        remoteDeviceId={this.state.remoteDeviceId}
        lat={this.state.lat}
        lng={this.state.lng}
        onChangeOfName={this.onChangeOfName}
        onChangeOfSerialNo={this.onChangeOfSerialNo}
        onChangeOfName_mv={this.onChangeOfName_mv}
        onChangeOfName_sv={this.onChangeOfName_sv}
        onChangeOfVMStreet={this.onChangeOfVMStreet}
        onChangeOfVMCity={this.onChangeOfVMCity}
        onChangeOfVMState={this.onChangeOfVMState}
        onChangeOfVMCohort={this.onChangeOfVMCohort}
        onChangeOfPayments={this.onChangeOfPayments}
        onChangeOfLng={this.onChangeOfLng}
        onChangeOfLat={this.onChangeOfLat}
        onChangeOfImageId={this.onChangeOfImageId}
        onChangeOfSharePercentage={this.onChangeOfSharePercentage}
        onChangeOfRemoteBoardId={this.onChangeOfRemoteBoardId}
        onChangeOfRemoteBluetoothId={this.onChangeOfRemoteBluetoothId}
        onChangeOfRemoteComId={this.onChangeOfRemoteComId}
        onChangeRemoteDeviceId={this.onChangeRemoteDeviceId}
        onChangeOfVMTypeId={this.onChangeOfVMTypeId}
        onChangeOfHardWareTypeId={this.onChangeOfHardWareTypeId}
        onChangeOfLocationTypeId={this.onChangeOfLocationTypeId}
        onChangeOfIsConsumerAppEnabled={this.onChangeOfIsConsumerAppEnabled}
        onChangeOfIsHealthAppEnabled={this.onChangeOfIsHealthAppEnabled}
        handleCreateVM={this.handleCreateVM}
        handleBack={this.handleBack}
        loading={this.state.loading}
        stateLoading={this.state.stateLoading}
        stateList={this.state.stateList}
        cityList={this.state.cityList}
        cityLoading={this.state.cityLoading}
        vmTypeOptions={this.state.vmTypeOptions}
        vmTypeLoading={this.state.vmTypeLoading}
        vmSeedMachineData={this.state.fetchSeeddata}
        cohorts={this.state.cohorts.sort()}
        payments={this.state.payments}
        hardware_types={this.state.hardware_types}
        location_types={this.state.location_types}
        warehouses={this.state.warehouses}
        corporates={this.state.corporates}
        machine_types={this.state.machine_types}
        cohortvalue={this.state.cohortvalue}
        paymentsvalues={this.state.paymentsvalues}
        paymentshandleSearchChange={this.state.paymentshandleSearchChange}
        searchPaymentsQuery={this.state.searchPaymentsQuery}
        vmSerial={this.state.vmSerialno}
        onChange_Capacity={this.onChange_Capacity}
        onChangeOWarehouse={this.onChangeOWarehouse}
        onChangeCorporates={this.onChangeCorporates}
        UploadImgFun={this.UploadImgFun}
        UploadImgBtn={this.UploadImgBtn}
        allPermission={this.state.allPermission}
        onChangeCartLimit={this.onChangeCartLimit}
        cart_Limt={this.state.cart_Limt}
        loader={this.state.loader}

       

      />
    );
  }
}

export default withRouter(
  connect(null, {
    getDataFromAPI,
    getseedDataFromAPI,
    CreatevmAPI,
    UploadImgAPI,
    getCityDataFromAPI,
  })(CreateVendingMachineContainer)
);



// WEBPACK FOOTER //
// ./src/Modules/VMCreate/container.jsx